
interface GAEventParams {
  [key: string]: string | number | boolean;
}

export const trackEvent = (eventName: string, params?: GAEventParams) => {
  try {
    if (typeof window !== 'undefined' && 'dataLayer' in window && window.dataLayer) {
      try {
        window.dataLayer.push({
          event: eventName,
          ...params
        });
        console.log('GA4 Event tracked:', eventName, params);
      } catch (err) {
        console.log('GA4 dataLayer blocked by CSP or browser policy');
      }
    } else {
      console.log('GA4 dataLayer not available for event:', eventName);
    }
  } catch (error) {
    // Fail silently to prevent disruption of the user experience
    console.warn('Failed to track GA4 event');
  }
};

// Predefined events
export const trackSignUp = (method: string) => {
  try {
    trackEvent('sign_up', { method });
  } catch (error) {
    console.warn('Failed to track sign up event');
  }
};

export const trackMeetingCreation = (meetingId: string, meetingType: string) => {
  try {
    trackEvent('meeting_created', {
      meeting_id: meetingId,
      meeting_type: meetingType
    });
  } catch (error) {
    console.warn('Failed to track meeting creation event');
  }
};

export const trackMeetingAnalysis = (meetingId: string, status: string) => {
  try {
    trackEvent('meeting_analysis_completed', {
      meeting_id: meetingId,
      analysis_status: status
    });
  } catch (error) {
    console.warn('Failed to track meeting analysis event');
  }
};

export const trackActionItemCreation = (actionItemId: string, meetingId?: string) => {
  try {
    trackEvent('action_item_created', {
      action_item_id: actionItemId,
      meeting_id: meetingId || 'standalone'
    });
  } catch (error) {
    console.warn('Failed to track action item creation event');
  }
};
